module.exports = "/_next/static/files/37d78840bd85d5bfe6a15dea240cf932.png";